import { render, staticRenderFns } from "./SondaggioRisposte.vue?vue&type=template&id=7da7b0f9&"
import script from "./SondaggioRisposte.vue?vue&type=script&lang=js&"
export * from "./SondaggioRisposte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports